import React, { Component, SyntheticEvent } from 'react'
import cx from 'classnames'
import _ from 'lodash'
import { hasExtension } from 'utils/functions'
import * as Yup from 'yup'
import { FieldProps } from 'formik'
import Dropzone from 'react-dropzone'
import Select from 'react-select'
import { Props as ReactSelectProps } from "react-select/src/Select"
import { ValueType } from 'react-select/src/types';

type TextFieldProps = {
	title: string
	textarea: boolean
	extraProps: React.HTMLProps<HTMLTextAreaElement>
}

export const TextField: React.FC<FieldProps<any> & TextFieldProps> = (props) => {
	const { field, form, title, textarea, ...extraProps  } = props
	return (
		<div className="common-form-input">
			<label>{title}</label>
			<div className="error">
				{form.touched[field.name] &&  form.errors[field.name]}
			</div>
			{textarea
				? <textarea
					{...extraProps}
					{...field}
				/>
				: <input
					type="text"
					{...extraProps}
					{...field}
				/>
			}
		</div>
	)
}


type SelectFieldProps = {
	title: string
	onChange: Function
	props: ReactSelectProps
}

export const SelectField: React.FC<FieldProps<any> & SelectFieldProps> = ({ field, form, title, onChange, ...props}) => (
	<div className="common-select">
		<label>{title}</label>
		{form.touched[field.name] &&  form.errors[field.name] &&
			<div className="error">{form.errors[field.name]}</div>
		}
		<Select
			{...props}
			clearable={false}
			value={field.value}
			styles={{
				control: (base: {}) => ({
					...base,
					minHeight: 44,
					fontSize: '1.0rem',
				})
			}}
			onChange={(e: ValueType<SyntheticEvent<typeof SelectField>>) => {
				if (onChange) {
					onChange(e)
				}
				return form.setFieldValue(field.name, e)}
			}
		/>
	</div>
)

type ImageFieldProps = {
	title: string
	cancelIcon?: string
}

export class ImageField extends Component<FieldProps<any> & ImageFieldProps> {
	state = {
		cancelled: false
	}

	handleChange = (files: FileList) => {
		const file = files[0]
		this.props.form.setFieldTouched(this.props.field.name, true)
		this.props.form.setFieldValue(this.props.field.name, file)
		this.setState({
			...this.state,
			cancelled: false
		})
	}

	static validator = Yup.mixed().test(
		'is under 4 mb',
		'Please upload a file under 4mb',
		value => {
			const isFile = value instanceof File
			return(!isFile) || value.size/1024/1024 < 4
		}
	).test(
		'is an image',
		'Please upload a valid image (png, jpg, jpeg)',
		value => {
			const isFile = value instanceof File
			return (!isFile) || hasExtension(value.name, ['png', 'jpg', 'jpeg'])
		}
	)

	reset = () => {
		this.props.form.setFieldTouched(this.props.field.name, true)
		this.props.form.setFieldValue(
			this.props.field.name,
			'__clear'
		)
		this.setState({
			...this.state,
			cancelled: true
		})
	}

	renderDropzone = () => (
		<div className="dropzone-container">
			<Dropzone
				//@ts-ignore
				onDrop={this.handleChange}
				multiple={false}
				className="dropzone"
			>
				<div className="dropzone-inner">
					<div className="dropzone-text">Add {this.props.title}</div>
					<div className={`icon icon-picture`}/>
				</div>
			</Dropzone>
		</div>
	)

	renderImageContainer = (image: string) => (
		<div className="image-container">
			<div
				className="image"
				style={{backgroundImage: `url(${image})`}}
			/>
			<div
				className={`cancel-icon ${this.props.cancelIcon || 'icon-cross'}`}
				onClick={this.reset}
			/>
		</div>
	)

	render() {
		const { field, form, title } = this.props
		const initialValue = form.initialValues[field.name]
		const hasValue = (initialValue || field.value instanceof File) && !this.state.cancelled
		return (
			<div className="common-radio">
				{form.touched[field.name] &&  form.errors[field.name] &&
					<div className="error">{form.errors[field.name]}</div>
				}
				<div className="dropzone-container">
					{ hasValue
						? this.renderImageContainer(field.value.preview || initialValue)
						: this.renderDropzone()
					}
				</div>
			</div>
		)
	}
}